<template>
  <!-- 赛事轮次管理页：按赛事 + 组别维度维护 初赛 / 复赛 / 决赛 等轮次 -->
  <div style="background:#fff; padding:20px;">
    <div style="margin-bottom:20px;">
      <a-select v-model="query.eventId" placeholder="选择赛事" allow-clear style="width:240px; margin-right:10px;" @change="handleEventChange">
        <a-select-option v-for="item in eventOptions" :key="item.id" :value="item.id">{{ item.title }}</a-select-option>
      </a-select>
      <a-select v-model="query.categoryId" placeholder="选择组别" allow-clear style="width:200px; margin-right:10px;">
        <a-select-option v-for="item in categoryOptions" :key="item.id" :value="item.id">{{ item.categoryName }}</a-select-option>
      </a-select>
      <a-button type="primary" icon="search" @click="handleSearch">查询</a-button>
      <a-button type="primary" icon="plus" style="margin-left:10px;" @click="handleAdd">新增轮次</a-button>
    </div>

    <a-table
      :columns="columns"
      :data-source="data"
      rowKey="id"
      :loading="loading"
      :pagination="pagination"
      @change="handleTableChange"
    >
      <span slot="eventTitle" slot-scope="text, record">{{ getEventTitle(record.eventId) }}</span>
      <span slot="categoryName" slot-scope="text, record">{{ record.categoryId ? getCategoryName(record.categoryId) : '全组别通用' }}</span>
      <span slot="status" slot-scope="text">
        <a-tag :color="statusColor(text)">{{ statusLabel(text) }}</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a-popconfirm title="确定删除吗？" @confirm="handleDelete(record.id)">
          <a style="color:red;">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal v-model="visible" :title="form.id ? '编辑轮次' : '新增轮次'" @ok="handleOk" width="600px">
      <a-form-model ref="formRef" :model="form" :rules="rules" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="所属赛事" prop="eventId">
          <a-select v-model="form.eventId" placeholder="请选择赛事" @change="handleFormEventChange">
            <a-select-option v-for="item in eventOptions" :key="item.id" :value="item.id">{{ item.title }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="所属组别">
          <a-select v-model="form.categoryId" placeholder="不选则该赛事所有组别通用" allow-clear>
            <a-select-option v-for="item in formCategoryOptions" :key="item.id" :value="item.id">{{ item.categoryName }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="轮次名称" prop="roundName">
          <a-input v-model="form.roundName" placeholder="如 初赛 / 复赛 / 半决赛 / 决赛" />
        </a-form-model-item>
        <a-form-model-item label="轮次编码">
          <a-input v-model="form.roundCode" placeholder="可选，如 PRELIM / SEMI / FINAL" />
        </a-form-model-item>
        <a-form-model-item label="轮次顺序">
          <a-input-number v-model="form.roundOrder" :min="0" style="width:100%;" />
        </a-form-model-item>
        <a-form-model-item label="轮次时间">
          <a-date-picker v-model="form.roundTime" show-time style="width:100%;" value-format="YYYY-MM-DD HH:mm:ss" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="form.status">
            <a-radio :value="0">未开始</a-radio>
            <a-radio :value="1">进行中</a-radio>
            <a-radio :value="2">已结束</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="说明">
          <a-textarea v-model="form.description" :rows="3" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {
  deleteDragonRound,
  getDragonCategoryList,
  getDragonEventList,
  getDragonRoundList,
  saveDragonRound
} from '@/api'

export default {
  data() {
    return {
      query: { eventId: undefined, categoryId: undefined },
      eventOptions: [],
      categoryOptions: [],
      formCategoryOptions: [],
      data: [],
      loading: false,
      visible: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true
      },
      form: {
        status: 0,
        roundOrder: 0
      },
      rules: {
        eventId: [{ required: true, message: '请选择赛事' }],
        roundName: [{ required: true, message: '请输入轮次名称' }]
      },
      columns: [
        { title: '所属赛事', key: 'eventTitle', scopedSlots: { customRender: 'eventTitle' } },
        { title: '所属组别', key: 'categoryName', scopedSlots: { customRender: 'categoryName' } },
        { title: '轮次名称', dataIndex: 'roundName' },
        { title: '编码', dataIndex: 'roundCode', width: 100 },
        { title: '顺序', dataIndex: 'roundOrder', width: 80 },
        { title: '轮次时间', dataIndex: 'roundTime', width: 170 },
        { title: '状态', dataIndex: 'status', width: 100, scopedSlots: { customRender: 'status' } },
        { title: '操作', key: 'action', width: 160, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  created() {
    this.loadEvents()
    this.loadData()
  },
  methods: {
    loadEvents() {
      getDragonEventList({ page: 1, pageSize: 200 }).then(res => {
        this.eventOptions = (res.data && res.data.list) || []
      })
    },
    loadCategories(eventId, target = 'categoryOptions') {
      if (!eventId) {
        this[target] = []
        return
      }
      getDragonCategoryList({ eventId }).then(res => {
        this[target] = (res.data && res.data.list) || []
      })
    },
    getEventTitle(eventId) {
      const event = this.eventOptions.find(item => item.id === eventId)
      return event ? event.title : ''
    },
    getCategoryName(categoryId) {
      // 合并两个可能的组别数据源，保证列表和表单内的组别信息都能被查到
      const all = [...this.categoryOptions, ...this.formCategoryOptions]
      const item = all.find(c => c.id === categoryId)
      return item ? item.categoryName : ''
    },
    statusColor(status) {
      if (status === 1) return 'blue'
      if (status === 2) return 'green'
      return 'default'
    },
    statusLabel(status) {
      if (status === 1) return '进行中'
      if (status === 2) return '已结束'
      return '未开始'
    },
    handleEventChange(eventId) {
      this.query.categoryId = undefined
      this.loadCategories(eventId, 'categoryOptions')
    },
    handleFormEventChange(eventId) {
      this.form.categoryId = undefined
      this.loadCategories(eventId, 'formCategoryOptions')
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    loadData() {
      this.loading = true
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        eventId: this.query.eventId,
        categoryId: this.query.categoryId
      }
      getDragonRoundList(params).then(res => {
        this.data = (res.data && res.data.list) || []
        this.pagination.total = (res.data && res.data.total) || 0
      }).finally(() => {
        this.loading = false
      })
    },
    handleAdd() {
      this.form = {
        eventId: this.query.eventId,
        categoryId: undefined,
        status: 0,
        roundOrder: 0
      }
      this.formCategoryOptions = []
      if (this.query.eventId) {
        this.loadCategories(this.query.eventId, 'formCategoryOptions')
      }
      this.visible = true
    },
    handleEdit(record) {
      this.form = { ...record }
      this.formCategoryOptions = []
      if (record.eventId) {
        this.loadCategories(record.eventId, 'formCategoryOptions')
      }
      this.visible = true
    },
    handleOk() {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        saveDragonRound(this.form).then(() => {
          this.$message.success('保存成功')
          this.visible = false
          this.loadData()
        })
      })
    },
    handleDelete(id) {
      deleteDragonRound({ id }).then(() => {
        this.$message.success('删除成功')
        this.loadData()
      })
    }
  }
}
</script>
